var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7500_13802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.339844,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7500_13802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75678 15.9232C3.39137 15.9232 3.07671 15.7913 2.81283 15.5274C2.54894 15.2635 2.41699 14.9488 2.41699 14.5834V6.09632C2.41699 5.73091 2.54894 5.41625 2.81283 5.15236C3.07671 4.88848 3.39137 4.75653 3.75678 4.75653H16.2439C16.619 4.75653 16.9361 4.88848 17.1951 5.15236C17.4541 5.41625 17.5837 5.73091 17.5837 6.09632V14.5834C17.5837 14.9488 17.4541 15.2635 17.1951 15.5274C16.9361 15.7913 16.619 15.9232 16.2439 15.9232H3.75678ZM16.5003 7.14591L10.3641 10.7582C10.3066 10.7944 10.2473 10.823 10.1862 10.8438C10.125 10.8647 10.0631 10.8751 10.0003 10.8751C9.93088 10.8751 9.87241 10.8647 9.82491 10.8438C9.77727 10.823 9.72199 10.7965 9.65908 10.7644L3.50033 7.14591V14.5834C3.50033 14.6583 3.52435 14.7197 3.57241 14.7678C3.62046 14.8158 3.68192 14.8399 3.75678 14.8399H16.2439C16.3187 14.8399 16.3802 14.8158 16.4282 14.7678C16.4763 14.7197 16.5003 14.6583 16.5003 14.5834V7.14591ZM10.0003 9.56903L16.3514 5.83986H3.67012L10.0003 9.56903ZM3.50033 6.87716V7.04841V6.22924V6.24361V6.21716V7.05028V6.87882V14.8399V6.87716Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fa31f006587a6f6dec50afa844ccd8da.svg";
export { ForwardRef as ReactComponent };